import React from 'react';
import DataTable from 'react-data-table-component';
import { customTableStyles } from '../../../utils/tableStylings';

const TableDisplay = ({ title, data }) => {
  if (!data || data.length === 0) {
    return <div className="text-muted">No {title.toLowerCase()} data available.</div>;
  }

  // Create columns dynamically based on first row keys
  const columns = Object.keys(data[0]).map((key) => ({
    name: key,
    selector: (row) => row[key],
    sortable: true,
    wrap: true,
  }));

  return (
    <div>
      <h5 className="mb-3">{title} Table</h5>
      <DataTable
        columns={columns}
        data={data}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        customStyles={customTableStyles}
      />
    </div>
  );
};

export default TableDisplay;
